export default {
    /**
     * 页面配置数据（根据版本号和页面ID获取的），版本号为空则获取正在使用的数据【配置为空会返回测试数据】
     * @param {pageid：页面ID,version：版本号,schemaType:0代表布局组件、1代表业务组件} params 
     * @returns 
     */
    fetchPageSettingDataForVersion(params){
        params.savetype = IDM.setting.pageSchema.saveType;
        //如果是磁盘直接读取json文件
        if(IDM.setting.pageSchema.saveType=="disk"&&params.version&&process.env.NODE_ENV =="production"){
            return IDM.http.get(IDM.setting.pageSchema.jsonDir.replace(/{projectNo}/g, params.projectNo||IDM.setting.webRoot.projectNo).replace(/{pageid}/g,params.pageid).replace(/{version}/g,params.version));
        }
        return IDM.http.get(IDM.setting.api.pageSettingDataUrl||IDM.setting.mockurl.pageSettingDataUrl,params);
    },
    /**
     * 获取应用信息
     * @param {*} url 配置的接口地址
     * @param {pageid：页面ID} params 
     * @returns 
     */
    fetchApplicationInfo(url,params){
        return IDM.http.get(url,params);
    },
    /**
     * 获取当前登录用户信息
     * @param {*} url 配置的接口地址
     * @param {pageid：页面ID} params 
     * @returns 
     */
    fetchUserInfo(url,params){
        return IDM.http.get(url,params);
    },
    /**
     * 获取当前登录用户个性化定制的信息
     * @param {*} url 配置的接口地址
     * @param {pageid：页面ID} params 
     * @returns 
     */
    fetchUserCustomizationInfo(url,params){
        return IDM.http.get(url,params);
    },
    /**
     * 获取当前应用主题信息
     * @param {*} url 配置的接口地址
     * @param {pageid：页面ID} params 
     * @returns 
     */
    fetchThemeInfo(url,params){
        return IDM.http.get(url,params);
    },
    /**
     * 获取页面接口数据（get）
     * @param {*} url 
     * @param {*} params 
     */
    getPageInterfaceInfo(url,params){
        return IDM.http.get(url,params);
    },
    /**
     * 请求页面接口数据（post）
     * @param {*} url 
     * @param {*} params 
     * @param {*} options 
     * @returns 
     */
    postPageInterfaceInfo(url,params,options){
        return IDM.http.post(url,params,options);
    }
}